import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { withStyles } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import classNames from 'classnames';
import { formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './styles';

function ADGMItemDetails(props) {
  const {
    label,
    value,
    labelPlaceholder,
    classes,
    valueClass,
    isAmount,
    isLokalisedValue,
    valueLabel,
    showLabelOnly,
    labelClass,
    isDateFormat,
    isValueArray,
  } = props;

  const { lang } = useSelector(
    createSelector(
      state => state.language,
      language => ({
        lang: language.locale,
      }),
    ),
  );

  const isAr = lang === 'ar';
  const checkLokaliseKey = key => {
    if (messages[key])
      return <FormattedMessage {...messages[key]} {...(labelPlaceholder && { values: { ...labelPlaceholder } })} />;
    return key;
  };
  const checkLokaliseValue = key => {
    if (isLokalisedValue) {
      if (messages[key])
        return <FormattedMessage {...messages[key]} {...(valueLabel && { values: { ...valueLabel } })} />;
    }
    return key;
  };

  const dateFormat = <FormattedMessage {...messages.DD_MM_YY} />;
  return (
    <>
      <Typography
        className={classNames(
          classes.subtitle1,
          !isAr ? classes.textTransform : classes.marginBttom4pxForArabicLabels,
          labelClass,
        )}
      >
        {checkLokaliseKey(label)}
        {isDateFormat ? ` (${dateFormat.props.defaultmessages})` : ''}
      </Typography>
      {isValueArray ? (
        isValueArray.map(item => {
          return (
            <Typography variant='body1' className={classNames(classes.body1, isAr && classes.textAr, valueClass)}>
              {keyEmptyCheck(item)}
            </Typography>
          );
        })
      ) : (
        <Typography variant='body1' className={classNames(classes.body1, isAr && classes.textAr, valueClass)}>
          {isAmount ? (
            <FormattedMessage {...messages.AED_amount} values={{ num: formatCurrencyWithoutCurrency(value) }} />
          ) : isEmpty(value) && !isNumber(value) && !showLabelOnly ? (
            '-'
          ) : (
            checkLokaliseValue(value)
          )}
        </Typography>
      )}
    </>
  );
}

ADGMItemDetails.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  labelPlaceholder: PropTypes.object,
  classes: PropTypes.object.isRequired,
  valueClass: PropTypes.object,
  labelClass: PropTypes.object,
  isAmount: PropTypes.bool,
  isLokalisedValue: PropTypes.bool,
  valueLabel: PropTypes.object,
  showLabelOnly: PropTypes.bool,
  isDateFormat: PropTypes.bool,
  isValueArray: PropTypes.array,
  isArabic: PropTypes.bool,
};
ADGMItemDetails.defaultProps = {
  labelPlaceholder: null,
  valueClass: null,
  isAmount: false,
  isLokalisedValue: false,
  valueLabel: null,
  showLabelOnly: false,
  labelClass: null,
  isDateFormat: false,
  isValueArray: null,
  isArabic: false,
};
export default withStyles(styles)(ADGMItemDetails);
